import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { SaveChanges } from 'components/SaveChanges'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { getAdminConfig, setAdminConfig } from 'services'
import { MultiSelect, Toggle } from 'stories/components'

export const HardcodedTasksConfig = () => {
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState<Record<string, any>>({})
  const [hardcodedTaskList, setHardcodedTaskList] = useState<Record<string, string>>({})
  const [isChanged, setChanged] = useState(false)
  const loanGlobalStatus = useSelector((state: any) => state.loanGlobalStatus)

  useEffect(() => {
    setLoading(true)
    getAdminConfig('taskHardcoded')
      .then((res) => {
        setData(res.data || {})
        setHardcodedTaskList(res.taskList)
      })
      .finally(() => setLoading(false))
  }, [])

  const onChange = (key: string, value: boolean) => {
    const newData = cloneDeep(data)
    newData[key] = {
      enabled: value,
      loanStatus: newData[key]?.loanStatus || {},
    }
    setData(newData)
    setChanged(true)
  }

  const onSave = () => {
    setLoading(true)
    setAdminConfig('taskHardcoded', data)
      .then(() => toast('Configuration is stored successfully.', { type: 'info' }))
      .finally(() => {
        setLoading(false)
        setChanged(false)
      })
  }

  const onStatusChange = (key: string, value: Record<string, boolean>) => {
    const newData = cloneDeep(data)
    newData[key] = {
      enabled: newData[key]?.enabled ?? true,
      loanStatus: value,
    }
    setData(newData)
    setChanged(true)
  }

  return (
    <div>
      <LayoutLoading show={isLoading} />
      <SaveChanges show={isChanged} onSave={onSave} />

      <div className="space-y-4">
        {Object.keys(hardcodedTaskList).map((key, index) => {
          return (
            <div key={key} className="grid grid-cols-1 md:grid-cols-12 items-start md:items-center border-b pb-3">
              <div className="md:col-span-6">
                <span className="font-medium text-gray-900 dark:text-gray-300">
                  {index + 1}. {hardcodedTaskList[key]}
                </span>
              </div>

              <div className="md:col-span-4">
                <MultiSelect
                  id={`status-${key}`}
                  title="Select Loan Statuses"
                  options={loanGlobalStatus}
                  value={data[key]?.loanStatus || {}}
                  onChange={(value) => onStatusChange(key, value)}
                />
              </div>

              <div className="md:col-span-2 flex flex-col items-end">
                <Toggle
                  id={key}
                  value={data[key]?.enabled ?? true}
                  onChange={(value) => onChange(key, value)}
                  title="Enable / Disable"
                />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
